import { cbboFpoSummaryApiUrl, fpoEnquiriesApiUrl, fpoEnquiriesCRUDApiUrl, oldShopEnquiriesApiUrl, shopBulkOrderEnquiryPatchViewApiUrl, shopBulkOrderEnquiryViewApiUrl, websiteEnquiriesApiUrl } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getWebEnquiries = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(websiteEnquiriesApiUrl + "?page_size=50&" + query ?? "", config);

    return response;
};

export const patchWebEnquiry = async ({ id, data }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(websiteEnquiriesApiUrl + "/" + id + "/", data, config);
    return response;
};

export const getFpoEnquiries = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(fpoEnquiriesApiUrl + "?page_size=50&" + query ?? "", config);

    return response;
};

export const getFpoSummary = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(cbboFpoSummaryApiUrl, config);
    return response;
};

export const getOldShopEnquiries = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(oldShopEnquiriesApiUrl + "?page_size=50&" + query ?? "", config);

    return response;
};

export const getBulkEnquiries = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    // const response = await axios.get(shopBulkOrderEnquiryViewApiUrl + "?page_size=50&" + query ?? "", config);
    const response = await axios.get(shopBulkOrderEnquiryViewApiUrl, config);

    return response;
};

export const patchBulkEnquiry = async ({ data, id }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(shopBulkOrderEnquiryPatchViewApiUrl + id + "/", data, config);

    return response;
};

export const patchFpoEnquiry = async ({ data, id }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(fpoEnquiriesCRUDApiUrl + id + "/", data, config);

    return response;
};
